// Generated from Mozaik Data/Doors/CW MDF Doors/Doors.dat -- names must match Mozaik exactly.
window.PROFILES = [
 {
  "id": "SLAB",
  "name": "Slab",
  "sr": 0,
  "panel": "slab",
  "mozaik": {
   "door": "CW Slab",
   "drawer": "CW Slab DRW"
  }
 },
 {
  "id": "CW01",
  "name": "Shaker",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW01 Shaker SR2-50 PR250 DR",
   "glass": "CW01 Shaker SR2-50 PR250 DR Glass",
   "rr": "CW01 Shaker SR2-50 PR250 RR",
   "drawer": "CW01 Shaker SR2-50 PR250 DRW"
  }
 },
 {
  "id": "CW02",
  "name": "60V Shaker",
  "sr": 2.5,
  "panel": "flat",
  "bevel": 60,
  "mozaik": {
   "door": "CW02 60V SR2-50 PR250 DR",
   "glass": "CW02 60V SR2-50 PR250 DR Glass",
   "rr": "CW02 60V SR2-50 PR250 RR",
   "drawer": "CW02 60V SR2-50 PR250 DRW"
  }
 },
 {
  "id": "CW03",
  "name": "Double Shaker",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW03 DBL Shaker SR2-50 PR250 DR",
   "rr": "CW03 DBL Shaker SR2-50 PR250 RR",
   "drawer": "CW03 DBL Shaker SR2-50 PR250 DRW"
  }
 },
 {
  "id": "CW04",
  "name": "60V with Line",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW04 60V with Line SR2-50 PR250 DR",
   "rr": "CW04 60V with Line SR2-50 PR250 RR",
   "drawer": "CW04 60V with Line SR2-50 PR250 DRW"
  }
 },
 {
  "id": "CW05",
  "name": "Slim Shaker",
  "sr": 1.25,
  "panel": "flat",
  "mozaik": {
   "door": "CW05 Slim Shaker  DR ",
   "drawer": "CW05 Slim Shaker DRW"
  }
 },
 {
  "id": "CW06",
  "name": "Tacoma",
  "sr": 3.25,
  "panel": "flat",
  "mozaik": {
   "door": "CW06 Tacoma-1PC DR SR3-25 ",
   "rr": "CW06 Tacoma DWR SR3-25 RR",
   "drawer": "CW06 Tacoma-DWR SR3-25"
  }
 },
 {
  "id": "CW07",
  "name": "Denver",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW07 Denver Door",
   "glass": "CW07 Denver Glass Door",
   "rr": "CW07 Denver Reduced",
   "drawer": "CW07 Denver Drawer"
  }
 },
 {
  "id": "CW08",
  "name": "Auburn",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW08 Auburn Door",
   "rr": "CW08 Auburn Reduced",
   "drawer": "CW08 Auburn Drawer"
  },
  "minH": {
   "drawer": 8,
   "rr": 5.25
  }
 },
 {
  "id": "CW09",
  "name": "Fuji",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW09 Fuji Door",
   "drawer": "CW09 Fuji Drawer"
  }
 },
 {
  "id": "CW10",
  "name": "Step Bead",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW10 Step Bead DR",
   "rr": "CW10 Step Bead RR DWR",
   "drawer": "CW10 Step Bead DWR"
  }
 },
 {
  "id": "CW11",
  "name": "Raised Panel Step Bead",
  "sr": 2.25,
  "panel": "rp",
  "mozaik": {
   "door": "CW11 RP Step Bead 1PC DR SR2-25",
   "rr": "CW11 RP Step Bead 1PC RR SR2-25",
   "drawer": "CW11 RP Step Bead 1PC DWR SR2-25"
  }
 },
 {
  "id": "CW12",
  "name": "Madison Raised Panel",
  "sr": 2.25,
  "panel": "rp",
  "mozaik": {
   "door": "CW12 RP Madison 1PC DR SR2-25_RP",
   "rr": "CW12 RP Madison 1PC RR SR2-25_RP",
   "drawer": "CW12 RP Madison 1PC DWR SR2-25_RP"
  }
 },
 {
  "id": "CW13",
  "name": "Slim 150V",
  "sr": 1.5,
  "panel": "flat",
  "bevel": 150,
  "mozaik": {
   "door": "CW13 Slim 150V Door",
   "drawer": "CW13 Slim 150V DRW"
  }
 },
 {
  "id": "CW14",
  "name": "Inside Bead",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW14 Inside Bead SR2-50 PR250 DR",
   "glass": "CW14 Inside Bead SR2-50 PR250 Glass DR",
   "rr": "CW14 Inside Bead SR2-50 PR250 DRW RR",
   "drawer": "CW14 Inside Bead SR2-50 PR250 DRW"
  }
 },
 {
  "id": "CW15",
  "name": "Skinny Bead",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW15 Skinny Bead125 Door",
   "drawer": "CW15 Skinny Bead Drawer"
  }
 },
 {
  "id": "CW16",
  "name": "Double Bead",
  "sr": 2.5,
  "panel": "flat",
  "mozaik": {
   "door": "CW16 Double Bead",
   "glass": "CW16 Double Bead SR2-50 PR250 Glass DR ",
   "rr": "CW16 Double Bead RR DRW",
   "drawer": "CW16 Double Bead Drw"
  }
 },
 {
  "id": "CW18",
  "name": "Eric Raised Panel",
  "sr": 2.5,
  "panel": "rp",
  "mozaik": {
   "door": "CW18 RP Eric DR",
   "drawer": "CW18 RP Eric RR DRW"
  }
 }
];
